export default "<p>\n  base works!\n</p>\n";